import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "../../authorization";
import { type Schema, zql } from "../../generatedDrizzleSchema";
import { isTenantScopeGrant } from "../permissions";

export const MIN_TENANT_ADMINS = 1;

export const LAST_ADMIN_ERROR = "Cannot remove the last tenant admin";

type Tx = Pick<Transaction<Schema>, "run">;

export async function assertNotLastAdmin(
  tx: Tx,
  tenantId: string,
  userId: string
): Promise<void> {
  const otherAdminGrants = await tx.run(
    zql.roleGrants
      .where("tenantId", tenantId)
      .where("builtinRoleId", "tenant_admin")
      .whereExists("user", (u) =>
        u.where("deactivated", false).where("id", "!=", userId)
      )
  );
  if (otherAdminGrants.filter(isTenantScopeGrant).length < MIN_TENANT_ADMINS) {
    throw userFacingError(LAST_ADMIN_ERROR);
  }
}
